export const FileUploadItems = [
	{
		key: "image",
		label: "Web Banner",
		dimensions: "1905x980",
		fileSize: "10485760",
		fileSizeText: "10MB",
		format: "JPEG, JPG",
		default: "imageUrl"
	},
	{
		key: "smallImage",
		label: "Web Banner Küçük",
		dimensions: "585x1080",
		fileSize: "10485760",
		fileSizeText: "10MB",
		format: "JPEG, JPG",
		default: "smallImageUrl"
	},
	{
		key: "mobileImage",
		label: "Mobil Banner",
		dimensions: "576x576",
		fileSize: "10485760",
		fileSizeText: "10MB",
		format: "JPEG, JPG",
		default: "mobileImageUrl"
	}
];

